import { createAction } from 'typesafe-actions'
import { AppActionTypes } from './types'
import { EstablishmentModel } from 'core/models/establishmentModel'

export const init = createAction(AppActionTypes.INIT)<boolean>()
export const setEstablishment = createAction(AppActionTypes.SET_ESTABLISHMENT)<EstablishmentModel>()
